import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { FieldNote } from './components/FieldNote';
import { WhyWeExist } from './components/WhyWeExist';
import { OurApproach } from './components/OurApproach';
import { HowWeEngage } from './components/HowWeEngage';
import { StartEngagement } from './components/StartEngagement';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-background text-foreground" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <FieldNote data-id="element-4" />
        <WhyWeExist data-id="element-5" />
        <OurApproach data-id="element-6" />
        <HowWeEngage data-id="element-7" />
        <StartEngagement data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}